import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Truck, Home, Package, Map, Clock, Settings, User, X, CircleEllipsis } from "lucide-react";
import Logo from "../../public/AfricFreshLogo-01.svg";

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen, activeTab, setActiveTab }) => {
  const navigate = useNavigate();

  const menuItems = [
    { id: "dashboard", icon: Home, label: "Dashboard", path: "/driver/dashboard" },
    { id: "available", icon: Package, label: "Available Order", path: "/driver/available" },
    { id: "pending", icon: CircleEllipsis, label: "Pending Delivery", path: "/driver/pending-delivery" },
    { id: "history", icon: Clock, label: "History", path: "/driver/history" },
    { id: "profile", icon: User, label: "Profile", path: "/driver/profile" },
    // { id: "settings", icon: Settings, label: "Settings", path: "/settings" },
  ];

  return (
    <motion.div
      initial={{ x: -300 }}
      animate={{ x: isSidebarOpen ? 0 : -300 }}
      className="fixed left-0 top-0 h-full w-64 bg-emerald-800 text-white p-4 shadow-lg z-20"
    >
      <div className="flex-col items-center justify-center mb-8">
      <div className="flex items-center justify-center bg-white ">
       <img src={Logo} alt="AfriFresh-Logo" className="w-48 h-20 mb-2" />
      </div>
        <div className="flex items-center justify-center space-x-2">
          <Truck className="w-8 h-8" />
          <span className="text-xl font-bold">Driver Portal</span>
        </div>
        <button onClick={() => setIsSidebarOpen(false)} className="lg:hidden">
          <X className="w-6 h-6" />
        </button>
      </div>

      <nav className="space-y-2">
        {menuItems.map((item) => (
          <motion.button
            key={item.id}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => {
              setActiveTab(item.id);
              navigate(item.path);
            }}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors duration-200 ${
              activeTab === item.id ? "bg-emerald-700" : "hover:bg-emerald-700/50"
            }`}
          >
            <item.icon className="w-5 h-5" />
            <span>{item.label}</span>
          </motion.button>
        ))}
      </nav>
    </motion.div>
  );
};

export default Sidebar;
